'use client';

import { FC } from 'react';

import { CardProps } from '@monoimin/sb-types';
import { Card } from '@monoimin/molecules/cards/Card';
import { trackAmplitudeEvent } from '@monoimin/analytics';

interface TrackableCardProps extends CardProps {
  carouselTitle: string | undefined;
  articleSlug: string;
  position: number;
  locale: string;
}

export const TrackableCard: FC<TrackableCardProps> = ({
  carouselTitle,
  articleSlug,
  position,
  locale,
  ...cardProps
}) => {
  const handleClick = () => {
    trackAmplitudeEvent({
      deviceId: '',
      userId: null,
      name: 'Read More Element Click',
      properties: {
        carousel_type: 'read_more',
        carousel_title: carouselTitle || 'Read More',
        article_slug: articleSlug,
        article_position: position + 1,
        language: locale,
      },
    });
  };

  return <Card {...cardProps} onClick={handleClick} />;
};
